<div
  *ngIf="loading?.show"
  class="fixed inset-0 flex justify-center items-start overflow-y-auto bg-black/40 backdrop-blur-sm z-30"
>
  <div class="bg-white rounded-3xl w-[90%] m-auto sm:max-w-sm">
    <div class="text-center my-8">
      <i class="fas fa-circle-notch fa-spin text-dark fa-3x"></i>
      <span class="text-dark mt-2 block text-sm">{{
        loading?.description ?? "Loading..."
      }}</span>
    </div>
  </div>
</div>
